import { EntityModel } from '@/interfaces'
import {
  ALL_BARGAIN_SETTINGS_QUERY,
  CREATE_BARGAIN_SETTINGS_MUTATION,
  DELETE_BARGAIN_SETTINGS_MUTATION,
  FORCE_DELETE_BARGAIN_SETTINGS_MUTATION,
  SINGLE_BARGAIN_SETTINGS_QUERY,
  UPDATE_BARGAIN_SETTINGS_MUTATION,
} from './graphql'
import bargainTierEntity from '@/entities/bargainTier/entity'

const travelBargainSettingsModel: EntityModel = {
  name: 'bargainSettings',
  namePlural: 'bargainSettings',
  uniqueName: 'travelBargainSettings',
  uniqueNamePlural: 'travelBargainSettings',
  path: 'travel/pricing/bargain_settings',
  baseUrl: '/travel/pricing/bargain_settings',
  translationPrefix: 'entities:travelBargainSettings.',
  getDisplayName: (values: any) => {
    return 'BARGAIN SETTINGS'
  },
  gql: {
    getAll: ALL_BARGAIN_SETTINGS_QUERY,
    getSingle: SINGLE_BARGAIN_SETTINGS_QUERY,
    create: CREATE_BARGAIN_SETTINGS_MUTATION,
    update: UPDATE_BARGAIN_SETTINGS_MUTATION,
    delete: DELETE_BARGAIN_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_BARGAIN_SETTINGS_MUTATION,
  },
  attributes: {
    active: {
      name: 'active',
      label: 'entities:travelBargainSettings.attributes.active.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    untilDaysBeforeStart: {
      name: 'untilDaysBeforeStart',
      label: 'entities:travelBargainSettings.attributes.untilDaysBeforeStart.label',
      type: 'value',
      dataType: 'number',
      defaultValue: 90,
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    bargainTier: {
      name: 'bargainTier',
      label: 'entities:travelBargainSettings.attributes.bargainTier.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return bargainTierEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelBargainSettingsModel
